import { create } from 'zustand'

/** The key that goes to the inbox and puts the cursor in its capture field. */
export const INBOX_KEY = 'i'

/**
 * "Take me to the inbox, ready to type."
 *
 * `c` already captures from anywhere without moving you, and that is the right
 * default for a thought you want to write down and forget. This is the other
 * intent: you want to *be* in the inbox — to add something and then deal with
 * what is already sitting there — and pressing `c`, capturing, closing the
 * dialog and then navigating was three steps for one decision.
 *
 * The nonce rather than a boolean is the point. Focus is a thing you ask for
 * repeatedly, and "please focus" is not a state that can be true — a flag
 * would have to be set and then unset, and the unset is the bug: press `i`
 * twice from the inbox and the second press does nothing. A counter that only
 * goes up cannot get stuck.
 */
export const useInboxFocus = create<{
  /** Bumped every time focus is asked for. Never read for its value. */
  nonce: number
  request: () => void
}>((set) => ({
  nonce: 0,
  request: () => set((state) => ({ nonce: state.nonce + 1 })),
}))
